// packages/shared-components/src/components/Switch/Switch.tsx
import { useRef, useState } from "react";
import { SwitchProps } from "./types";
import styles from "./Switch.module.css";

const DEFAULT_DEBOUNCE_MS = 300;

export function Switch({
  checked: controlledChecked,
  defaultChecked = false,
  onChange,
  disabled = false,
  className = "",
  debounceMs = DEFAULT_DEBOUNCE_MS,
}: SwitchProps) {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  const lastToggleAtRef = useRef(0);

  const isControlled = controlledChecked !== undefined;
  const checked = isControlled ? controlledChecked : internalChecked;

  const handleToggle = () => {
    if (disabled) return;

    const now = Date.now();
    const wait = Math.max(0, Number(debounceMs) || 0);
    if (wait > 0 && now - lastToggleAtRef.current < wait) {
      return;
    }
    lastToggleAtRef.current = now;

    const newChecked = !checked;

    if (!isControlled) {
      setInternalChecked(newChecked);
    }

    onChange?.(newChecked);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={`${styles.switch} ${checked ? styles.checked : ""} ${className}`.trim()}
      onClick={handleToggle}
    >
      <span className={styles.thumb} />
    </button>
  );
}
